import sanitizeHtml from 'sanitize-html';

export const parseHtml = (htmlString: string) => ({
  // eslint-disable-next-line @typescript-eslint/naming-convention
  __html: sanitizeHtml(htmlString, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(
      // eslint-disable-next-line dot-notation
      window['__swaStationMessageAllowedTags'],
    ),
    allowedAttributes: {
      // eslint-disable-next-line dot-notation
      '*': window['__swaStationMessageAllowedAttributes'],
    },
  }),
});
